import { ButtonIcon, Table } from "mta-rkvr-styles";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { get, remove } from "../api/fetch";
import { ContractMessagesResponseBody } from "../api/HomePageResponseTypes";
import { ColumnHeader, ContractMessage } from "../types/homepage/ContractMessages";
import { Paginator } from "../types/util/TableFunctionalityTypes";
import { mapClassifiersValuesToLabels } from "../util/classifierManager";
import { toLocaleDate } from "../util/conversionUtils";
import { CONTRACTS } from "../util/paths";

const ContractMessages = () => {
  const { t } = useTranslation();
  const tBase = "homePageAuth.contractMessages.";

  const [messages, setMessages] = useState<ContractMessage[]>();

  const [refreshObservable, setRefreshObservable] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const refresh = () => {
    setRefreshObservable(!refreshObservable);
  };

  useEffect(() => {
    getMessages();
  }, [refreshObservable]);

  const getMessages = (pageSize?: number, elementOffset?: number) => {
    if (isLoading) {
      return;
    }
    setLoading(true);
    get<ContractMessagesResponseBody>({
      endPoint: "contractMessages",
      queryParams: [
        { name: "limit", value: pageSize ? pageSize : 10 },
        { name: "offset", value: elementOffset ? elementOffset : 0 },
      ],
    }).then(async ({ body }) => {
      const { resultsList: messages } = body;
      const labelsObject = await mapClassifiersValuesToLabels([
        {
          type: "lepingType",
          values: messages.map((message) => message.lepinguLiik),
        },
        {
          type: "lepingTypeSubtype",
          values: messages.map((message) => message.lepinguAlamliik),
        },
      ]);

      setMessages(
        body.resultsList.map((message) => {
          return {
            ...message,
            lepinguLiik: {
              label: labelsObject.lepingType!.shift()!,
              value: message.lepinguLiik,
            },
            lepinguAlamliik: {
              label: labelsObject.lepingTypeSubtype!.shift()!,
              value: message.lepinguAlamliik,
            },
            saatmiseAeg: toLocaleDate(message.saatmiseAeg),
          };
        }),
      );
      setPaginator({
        pageSize: body.limit,
        elementOffset: body.offset,
        numberOfElements: body.resultCount,
        totalElements: body.totalCount,
      });
      setLoading(false);
    });
  };
  const [paginator, setPaginator] = useState<Paginator>();

  const onPagination = (paginator: { pageSize: number; elementOffset: number }) => {
    getMessages(paginator.pageSize, paginator.elementOffset);
  };

  const markDone = (id: number) => {
    remove<never>({ endpoint: "accountNotifications", pathParams: [id] }).then((res) => {
      res.ok && refresh();
    });
  };

  return (
    <>
      {messages && (
        <Table
          id={t(tBase + "title")}
          title={t(tBase + "title")}
          headers={Object.keys(ColumnHeader).map((header) => {
            return t(tBase + header);
          })}
          paginator={paginator}
          onPagination={onPagination}
          content={messages?.map((message) => {
            const { lepingId, lepinguAlamliik, lepinguLiik, lepinguNumber, saatmiseAeg, teade } = message;
            return {
              number: <Link to={`${CONTRACTS}/${lepingId}`}>{lepinguNumber}</Link>,
              liik: lepinguLiik.label,
              alamliik: lepinguAlamliik.label,
              teade,
              saatmiseAeg,
            };
          })}
          translate={t}
          rowIds={messages.map((message) => message.teateId)}
          editable
          customEditRowComponent={(obj: { rowId: number }) => (
            <ButtonIcon iconName={"icon-delete"} onClick={() => markDone(obj.rowId)} tooltip={t(tBase + "markDone")} />
          )}
        />
      )}
    </>
  );
};

export default ContractMessages;
